<template>
  <v-navigation-drawer
    v-model="dialog"
    right
    hide-overlay
    temporary
    fixed
    width="900"
    class=""
    tabindex="0"
  >
    <v-card
      flat
      tile
    >
      <BtnCloseDrawer @close="dialog = false"></BtnCloseDrawer>
      <div class="text-h5 tertiary--text mt-4 text-center">
        Notificação
      </div>
      <v-card-text class="mt-16 text-left ">
        <div class="mb-0 text-h5">
          {{ notification.title }}
        </div>
        <p class="text--secondary mb-0">
          {{ this.formatDate(notification.created_at, 'DD/MM/YYYY HH:mm') }}
        </p>
      </v-card-text>
      <v-card-text class="mt-10">
        <div v-html="notification.message"></div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>
<script>
import { format } from '@/plugins/helper'
import BtnCloseDrawer from '@/components/BtnCloseDrawer.vue'

export default {
  components: {
    BtnCloseDrawer,
  },
  mixins: [format],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    notification: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    value(val) {
      this.dialog = val
      if (val) {
      }
    },
    dialog(val) {
      this.$emit('input', val)
    },
  },
  methods: {},
}
</script>
